import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#006DB7',
    },
    secondary: {
      main: '#062C43',
    },
    success: {
      main: '#7AC142',
    },
    text: {
      primary: '#052C42'
    }
  },
  shape: {
    borderRadius: 16
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '23px',
        }
      }
    }, MuiTab: {
      styleOverrides: {
        root: {
          '&. Mui-selected': {
            color: '#062c43'
          }
        }
      }
    }
  }
});

export default theme;
